<template>
  <div class="lead-form">
    <h3 class="h2">{{ formHeadline }}</h3>
    <form 
      v-if="!formSubmitted" 
      id="demo-form" 
      @submit.prevent="submitForm"
      data-destination="pardot"
      data-pardot="2020-05-06/86j15l"
    >
      <div>
        <fieldset>
          <legend>Name</legend>
          <div class="lead-form__half">
            <label for="fname">First Name</label>
            <input
              v-model="form.fname"
              type="text"
              id="fname"
              @invalid="isInvalid"
              @blur="reCheck"
              autocomplete="given-name"
              required
            >
          </div>
          <div class="lead-form__half">
            <label for="lname">Last Name</label>
            <input
              v-model="form.lname"
              type="text"
              id="lname"
              @invalid="isInvalid"
              @blur="reCheck"
              autocomplete="family-name"
              required
            >
          </div>
        </fieldset>
        <fieldset>
          <legend>Contact Method</legend>
          <div class="lead-form__full">
            <label for="email">Email</label>
            <input
              v-model="form.email"
              type="email"
              id="email"
              @invalid="isInvalid"
              @blur="reCheck"
              autocomplete="email"
              required
            >
          </div>
        </fieldset>
        <fieldset>
          <legend>Phone and Business Name</legend>
          <div class="lead-form__half">
            <label for="phone">Phone Number</label>
            <input
              v-model="form.tel"
              type="tel"
              id="phone"
              @invalid="isInvalid"
              @blur="reCheck"
              autocomplete="tel"
              required
            >
          </div>
          <div class="lead-form__half">
            <label for="bname">Business Name</label>
            <input
              v-model="form.business"
              type="text"
              id="bname"
              @invalid="isInvalid"
              @blur="reCheck"
              autocomplete="organization"
              required
            >
          </div>
        </fieldset>
        <fieldset>
          <legend>Current Distributor or Retailer</legend>
          <div class="lead-form__full">
            <label for="current">Current Office Coffee Distributor/Retailer</label>
            <input
              v-model="form.current"
              type="text"
              id="current"
              @invalid="isInvalid"
              @blur="reCheck"
              autocomplete="current"
              required
            >
          </div>
        </fieldset>
      </div>
      <div class="lead-form__check">
        <fieldset>
          <input v-model="form.optIn" type="checkbox" id="acknowledgement" name="acknowledgement">
          <label for="acknowledgement">Yes! I would love to receive email updates from Smucker Away From Home, including future promotions, offers and product information.</label>
        </fieldset>
      </div>
      <input v-model="form.persona" type="hidden" name="persona">
      <button class="button button--green" type="submit">{{ buttonText }}</button>
      <!-- <button class="button button--green" type="button" @click="fakeSubmit()">Fake Submit</button> -->
    </form>
    <!-- <div v-if="type === 'suppliers' && formSubmitted" class="suplier-hero__form">
      <p>
        Your download should automatically start, but if not, <a :href="`${assetPath}pdf/30902_ocs_operator_match_tool.pdf`">download Coffee Match Tool (PDF) here</a>.
      </p>
    </div> -->
    <div v-if="formSubmitted" class="lead-form__thanks">
      <p>Your office coffee match guide is downloading! You’ve also unlocked all the support below. For the custom offers, we’ll just need to know where to send them!</p>
      <p>If it hasn’t automatically downloaded, <a target="_blank" :href="assetPath + 'pdf/JMS_OCS_CustomerMatchTool_SupplierPDF.pdf'" data-gtmcat="OCS Engagement" data-gtmaction="click" data-gtmlabel="Download the Sales Guide">download the sales guide</a>.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import downloadjs from 'downloadjs'
// import VueRecaptcha from 'vue-recaptcha';
// import { reCaptchaKey } from './../../mixins/reCaptchaKey.js'
import { assetPath } from '../../mixins/assetPath'

export default {
  name: 'UnlockForm',
  components: {
    // VueRecaptcha,
  },
  data() {
    return {
      formSubmitted: false,
      form: {
        fname: null,
        lname: null,
        email: null,
        tel: null,
        business: null,
        current: null,
        optin: false,
        persona: this.$store.state.results.personaCalculated
      },
      formData: {},
      pardotId: '2021-07-23/8hfdhy',
      apiUrl: '/api/forms/postToPardot',
      buttonText: 'Unlock Support',
      sending: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'managers'
    },
  },
  computed: {
    rcResponse() {
      return this.$store.state.reCaptchaToken
    },
    formHeadline() {
      return this.formSubmitted ? 'Thank You!' : 'Unlock Custom Support'
    }
  },
  watch: {
    rcResponse(newToken) {
      // console.log('newToken', newToken)
      if (newToken) {
        // if it's this form we're sending, and not the sample form
        if (this.sending) {
          this.appendFormElements()
        }
      } else {
        console.error('ReCaptcha Fail')
        this.$emit('rcfail')
      }
    }
  },
  mounted () {
    // console.log('reCaptchaToken', this.$store.state.reCaptchaToken)
    // console.log('form', this.form)
  },
  methods: {
    isInvalid(event) {
      // console.log('isInvalid', event)
      event.target.classList.add('error')
    },
    reCheck(event) {
      event.target.classList.remove('error')
    },
    postSubmit() {
      const pdfUrl = this.assetPath + 'pdf/JMS_OCS_CustomerMatchTool_SupplierPDF.pdf'
      require('downloadjs')(pdfUrl);
      downloadjs('Suppliers PDF', this.assetPath + 'pdf/JMS_OCS_CustomerMatchTool_SupplierPDF.pdf', 'application/pdf');
    },
    appendFormElements() {
      this.formData = new FormData()
      this.formData.append('fname', this.form.fname)
      this.formData.append('lname', this.form.lname)
      this.formData.append('email', this.form.email)
      // this.formData.append('business', this.form.business)
      // this.formData.append('current', this.form.current)
      // this.formData.append('tel', this.form.tel)
      this.formData.append('optin', this.form.optin ? 'true' : 'false')
      // if (this.type === 'managers') { this.formData.append('persona', this.form.persona) }
      this.formData.append('pardot_url', `http://go.smuckerawayfromhome.com/l/555762/${this.pardotId}`)
      this.formData.append('response', this.rcResponse)
      // debugging
      // for (var pair of this.formData.entries()) {
      //   console.log(pair[0]+ ', ' + pair[1]); 
      // }
      // end debugging
      this.sendData()
    },
    submitForm() {
      this.buttonText = 'Sending'
      this.sending = true
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'submit',
          eventLabel: 'Unlock Form | ' + this.type + ' | Submit Attempt',
        });
      }
      this.$emit('executeRC')
    },
    async sendData() {
      await axios({
        method: 'post',
        url: this.apiUrl,
        data: this.formData,
        config: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache',
          },
        },
      })
      .then(response => {
        if (response.data.indexOf('error') > 0) {
          console.error('error response data: ', response.data)
          this.buttonText = 'Error'
          this.postSubmit()
          this.formSubmitted = true
          this.$store.dispatch('completed', true) // not going to punish the user for our failure here. All roads lead to suggestions.
          this.sending = false
          // eslint-disable-next-line
          if (typeof dataLayer === 'object') {
            // eslint-disable-next-line
            dataLayer.push({
              event: 'genericEvent',
              eventCat: 'OCS Engagement',
              eventAction: 'submit',
              eventLabel: 'Unlock Form | ' + this.type + ' | Pardot Error',
            });
          }
        }
        if (response.data.indexOf('Fail') > 0) {
          console.error('fail response data: ', response.data)
          // server RC Fail
          this.$emit('rcfail')
          // this.buttonText = 'Error'
          // this.postSubmit()
          // this.formSubmitted = true
          // this.$store.dispatch('emailSubmitted', true) // not going to punish the user for our failure here. All roads lead to suggestions.
        }
        if (response.data.indexOf('success') > 0) {
          this.formSuccess()
        }
      })
      .catch(error => {
        console.error('error: ', error)
        console.error('apiUrl', this.apiUrl)
        this.buttonText = 'Network Error'
        this.postSubmit()
        this.$store.dispatch('completeUnlockAction') // not going to punish the user for our failure here. All roads lead to suggestions.
        this.sending = false
        // eslint-disable-next-line
        if (typeof dataLayer === 'object') {
          // eslint-disable-next-line
          dataLayer.push({
            event: 'genericEvent',
            eventCat: 'OCS Engagement',
            eventAction: 'submit',
            eventLabel: 'Unlock Form | ' + this.type + ' | Network Error',
          });
        }
      })
    },
    formSuccess() {
      // console.log('success response data: ', response.data)
      this.buttonText = 'Sent'
      this.postSubmit()
      this.formSubmitted = true
      this.$store.dispatch('completeUnlockAction') // not going to punish the user for our failure here. All roads lead to suggestions.
      this.sending = false
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'submit',
          eventLabel: 'Unlock Form | ' + this.type + ' | No Errors',
        });
      }
    },
    fakeSubmit() {
      this.formSuccess()
    }
  },
  mixins: [assetPath]
}
</script>

<style lang="scss">

.lead-form {
  max-width: 582px;
  margin: 0 auto;
  p {
    color: $new-blue;
  }
  a {
    color: $green;
  }
  h3 {
    color: $blue;
    text-align: center;
    margin-bottom: 1em;
    font-size: 1.875em;
  }
  fieldset {
    display: flex;
    justify-content: space-between;
    text-align: left;
    margin: 0;
    border: none;
    padding: 0;
    legend {
      @include visually-hidden;
    }
  }
  form {
    display: block;
    margin-top: 1em;
    & > div:first-of-type {
      margin-bottom: 1em;
    }

    input:invalid,
    input.error {
      border: 1px solid $red;
    }
    input[type="email"],
    input[type="text"],
    input[type="tel"] {
      height: 46px;
      width: 100%;
      border-radius: 4px;
      box-shadow: none;
      border: 1px solid #969696;
      font-size: 16px;
      padding: 0.2em 0.8em;
      margin-bottom: 1em;
      &.error {
        border: 1px solid $error;
        background-color: $error-bg;
      }
    }
    // button[type="submit"] {
    //   height: 46px;
    //   border-radius: 0 4px 4px 0;
    //   background-color: $green;
    //   color: $text;
    //   &:hover {
    //     background-color: $green-hover;
    //   }
    // }
    label {
      display: block;
      font-size: 12px;
      text-transform: uppercase;
      color: $lgrayer;
      font-weight: 700;
      margin-bottom: 0.25em;
    }
  }
}

.lead-form__half {
  flex: 0 0 48.5%;
}
.lead-form__full {
  flex: 1 1 auto;
}
.lead-form__check {
  margin-bottom: 1em;
}

.lead-form__thanks {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2em;
  margin-top: -2em;
  p {
    text-align: center;
    color: $grayer;
    font-weight: 600;
    margin-bottom: 1em;
  }
}

</style>